chat:
  message:
    character-name:
      airi: AIRI
      core-system: Core System
      you: 당신
  reasoning: Reasoning
message: 듣고 있어요...
operations:
  load-models: 모델 불러오기
  load-models-status:
    loading: 로딩 중
    ready: Ready
select-a-audio-input: Select a Audio Input
select-a-model: 모델 선택
select-a-voice: Choose a voice
viewers:
  debug-menu:
    emotions: 감정
    emotions-btn:
      angry: 화남
      awkward: 어색함
      happy: 행복함
      neutral: '🙂 Neutral'
      question: '🤔 Question'
      sad: 슬픔
      surprised: 놀람
      think: '🤨 Think'
    vrm:
      camera: 카메라
      model:
        title: 모델
waiting: Waiting
